define(function() {
  var Auth = function () {
    this.defAction();
    this.defRecaptchaCallback();
    window.caOnboardingFormCallback = function() {
      $('.ca-onboarding-form.step_2 form').data('recaptcha-verified', true).submit()
    };
  };

  Auth.prototype.defRecaptchaCallback = function() {
    $('.ca-onboarding-form.step_2 form').on('submit', function(e) {
      if ($(this).data('recaptcha-verified')) return;

      e.preventDefault()
      window.grecaptcha.execute()
    });
  };

  Auth.prototype.defAction = function () {
    $('input[data-error]').each(function (indx, item) {
      this._makeError($(item));
    }.bind(this));
  };

  Auth.prototype._makeError = function ($el, msg) {
    var $parent = $($el.closest('.ca-form--textField')[0]) || null
      ,$iconError = $('<i class="fa fa-times"/>');

    if($el.data('error') == '' && msg === undefined) return;

    $el.data('rePlaceholder', $el.attr('placeholder'));
    $el.attr('placeholder', msg ? msg : $el.data('error'));
    if($el.val()) {
      $el.data('tmpVal', $el.val());
      $el.val('');
    }

    $parent.addClass('ca-textField__error').prepend($iconError);

    $el.one('click keydown', function (evt) {
      $parent.removeClass('ca-textField__error').find('.fa').remove();
      $el.attr('placeholder', $el.data('rePlaceholder'));
      if($el.data('tmpVal')) {
        $el.val( $el.data('tmpVal') );
      }

      $el.unbind('click keydown');
    });
  };

  Auth.prototype._makeChecked = function ($el) {
    if(!$el) return;

    var $iconCheck = $('<i class="fa fa-check"/>')
      ,classDirty = 'ca-textField__dirty';

    if($el.val() != '' && $el.data('error') == '') {

      $el.closest('.ca-form--textField').addClass( classDirty ).prepend( $iconCheck );
      $el.prop('readonly', true);
      // $el.one('click keydown', function () {
      //   $el.closest('.ca-form--textField').removeClass( classDirty ).find( '.fa' ).remove();
      //   $el.unbind('click keydown');
      // });
    }
  };

  // Auth.prototype.actionLogin = function () {
  //   console.log("actionLogin");
  //   this.applyFields();
  // };
  //
  // Auth.prototype.actionAddUser = function () {
  //   console.log("addUser");
  //   this.applyFields();
  // };

  Auth.prototype.actionAddCompany = function () {
    console.log("addCompany");

    var $step1 = $(".ca-onboarding-form.step_1")
      ,$step2 = $(".ca-onboarding-form.step_2")
      ,$form = $( $step2.find("form")[0] )
      // ,formIsDirty = false
      ,typeReg = $("#company_sign_up_signup_state").val() || null
      ,classHidden = "is-hidden";

    // $form.find("input").each(function () {
    //   var item = $(this);
    //
    //   if(item.attr('type') == 'hidden' || item.attr('type') == 'radio') return;
    //
    //   if(item.val() != '') {
    //     formIsDirty = true
    //   }
    // });

    //if(formIsDirty) {
    if(typeReg) {
      if(typeReg == 'as_member') {
        this._makeChecked($('#company_sign_up_email'));
        this._makeChecked($('#company_sign_up_company_name'));
        $form.find('.kinds').remove();
      }
      else if(typeReg == 'as_owner') {
        this._makeChecked($('#company_sign_up_email'));
      }
      $step2.removeClass(classHidden);
    }
    else {
      $step1.removeClass(classHidden);
    }

    $('.ca-form--btn__button--next').on('click', function () {
      var email = $('input[name="work_email"]').val() || null;

      if(!email || !$('input[name="work_email"]')[0].validity.valid) return;

      $.ajax({
        method: 'POST',
        url: '/company/sign_up/check_email',
        dataType: 'json',
        data: {
          email: email
        },
        success: function(data) {

          if(data.emailTaken === true) {
            this._makeError($('input[name="work_email"]'), 'Email has already been taken');
          }
          else {
            var company_name = data.name;
            $('#company_sign_up_email').val( email );
            
            this._makeChecked($('#company_sign_up_email'));
            if(company_name) {
              $('#company_sign_up_company_name').val( company_name );
              $('#company_sign_up_signup_state').val ( "as_member" );
              this._makeChecked($('#company_sign_up_company_name'));
              $form.find('.kinds').remove();
            }
            else {
              $('#company_sign_up_signup_state').val ( "as_owner" );
            }

            $step1.addClass( classHidden );
            $step2.removeClass( classHidden );
          }

        }.bind(this)
      });
    }.bind(this));
  };

  Auth.prototype.applyFields = function() {
    $(".field_with_errors .form-control").map(function() {
      var input = $(this);
      var msg = input.data("error");
      input.data("placeholder", input.attr("placeholder")).attr("placeholder", msg);
      input.data("value", input.val()).val("");
    });

    $(".field_with_errors .form-control").on("focus keyup", function(ev) {
      var input = $(this);

      if(ev.type == "focus") {
        input.val(input.data("value"));
      }
      $(input.parent()).removeClass("field_with_errors");
      input.attr("placeholder", input.data("placeholder"));
      input.unbind();
    });
  };

  return Auth;
});
